import { CurrentUserFields } from '../../generated/graphql';
import { isNewUser } from '@domain/user/isNewUser';

import { trackEvent } from './trackEvent';

export const trackLoginAndAccountCreation = (
  user: CurrentUserFields,
  signupMethod: string | undefined,
): void => {
  if (isNewUser(user.createdAt) && signupMethod) {
    trackEvent({ name: 'account_created', properties: { method: signupMethod } });
  }
  trackEvent({ name: 'nob_login_complete', properties: {} });
};
